import { Injectable }     from '@angular/core';
import {TrackerService} from './tracker';

declare let window: any;

const TOURS:any = {};
TOURS.console = {
  id: 'console',
  steps: [{
    title: "API Console",
    target: ".breadcrumbs",
    placement: 'bottom',
    content: `
Welcome to the API Console. Here you can make test calls to the API,
see how it responds, and generate code for calling the API in a
few different languages.
`,
  }, {
    title: "Choose an Operation",
    target: ".side-menu",
    placement: 'right',
    content: `
Use this menu to choose which operation you want to call.
`,
  }, {
    title: "Set Parameters",
    target: '.parameters-title',
    placement: 'top',
    content: `
Most operations will need some input. You can fill out any
parameters here.
`
  }, {
    title: "Sample Code",
    target: 'sample-code',
    placement: 'top',
    content: `
As you fill out the parameters, you can see sample code for
making the same API call in a number of different programming languages.
`
  }, {
    title: "Send the Request",
    target: '.execute-button',
    placement: 'bottom',
    content: `
When you're ready, hit this button to send the request.
`
  }],
}

@Injectable()
export class TourService {
  tours:any = TOURS;

  constructor(private tracker:TrackerService) {}

  startTour(name) {
    this.tracker.track('tour', {name});
    window.hopscotch.endTour();
    let tour = JSON.parse(JSON.stringify(this.tours[name]));
    tour.steps
          .filter(s => typeof s.target === 'string')
          .forEach(s => s.target = window.document.querySelector(s.target));
    return window.hopscotch.startTour(tour);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tour.ts